import { Checkbox, FormControl, FormErrorMessage, Link } from "@chakra-ui/react";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

export interface ConsentFieldValues {
  acceptedTermsOfService: boolean;
  acceptedPrivacyPolicy: boolean;
}

export const ConsentCheckboxes = () => {
  const { t } = useTranslation();
  const { control, formState } = useFormContext<ConsentFieldValues>();
  const errors = formState.errors;

  return (
    <>
      <FormControl isInvalid={errors.acceptedPrivacyPolicy !== undefined} mt="10px">
        <Controller
          name="acceptedPrivacyPolicy"
          control={control}
          rules={{
            required: { value: true, message: t("Please accept our Privacy Policy before logging in.") },
          }}
          render={({ field: { onChange, value } }) => (
            <Checkbox isChecked={value} onChange={onChange}>
              {t("I accept the")}{" "}
              <Link href="https://sourcemagnet.com/privacy-policy" color="blue.500" target="_blank">
                <u>{t("Privacy Policy")}</u>
              </Link>
            </Checkbox>
          )}
        />
        <FormErrorMessage>{errors.acceptedPrivacyPolicy?.message}</FormErrorMessage>
      </FormControl>
      <FormControl isInvalid={errors.acceptedTermsOfService !== undefined} mt="10px">
        <Controller
          name="acceptedTermsOfService"
          control={control}
          rules={{
            required: { value: true, message: t("Please accept our Terms of Service before logging in.") },
          }}
          render={({ field: { onChange, value } }) => (
            <Checkbox isChecked={value} onChange={onChange}>
              {t("I accept the")}{" "}
              <Link href="https://sourcemagnet.com/avtalevilkar" color="blue.500" target="_blank">
                <u>{t("Terms of Service")}</u>
              </Link>
            </Checkbox>
          )}
        />
        <FormErrorMessage>{errors.acceptedTermsOfService?.message}</FormErrorMessage>
      </FormControl>
    </>
  );
};
